import React from 'react';
import _ from 'lodash';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { green } from '@mui/material/colors';
import { useQuery } from 'react-fetching-library';
import { useDispatch, useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import { useTranslation } from 'react-i18next';

import { getSeasonsAction } from '../../../../services/request';
import { setSeason, setSeasonIdentifier, setSeasonYear } from '../../../../services/redux-actions';

const styles = {
  select: {
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: green[400]
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: green[600]
    },
    width: '100%'
  }
};

export const SeasonList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { season, module } = useSelector(state => state.app);
  const { loading, payload, error } = useQuery(getSeasonsAction(null, 'GET'));
  const [seasons, setSeasons] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setSeasons(payload.results);
      const s = _.filter(payload.results, obj => obj.id == season);
      if (!season || _.isEmpty(s)) {
        if (payload.results.length > 0) {
          dispatch(setSeasonIdentifier(payload.results[0].identifier));
          dispatch(setSeason(payload.results[0].id));
          dispatch(setSeasonYear(payload.results[0].year));
        }
      }
    }
  }, [loading, module]);

  const handleChange = useDebouncedCallback(val => {
    dispatch(setSeasonIdentifier(seasons.filter(s => s.id == val)[0].identifier));
    dispatch(setSeasonYear(seasons.filter(s => s.id == val)[0].year));
    dispatch(setSeason(val));
  }, 50
  );

  return (
    <Box>
      <InputLabel id="seasons"><Typography color="primary">{t('season')}</Typography></InputLabel>
      <Select
        sx={styles.select}
        variant="standard"
        labelId="seasons"
        value={season}
        defaultValue={season}
        label="Sezony"
        onChange={e => handleChange(e.target.value)}
      >
        { !_.isEmpty(seasons)
          ? _.map(seasons, obj => (
            <MenuItem key={obj.id} value={obj.id}>{obj.pl_name}</MenuItem>
          ))
          : []}
      </Select>
    </Box>
  );

};
